module.exports = __webpack_public_path__ + "img/pf.62a45c97.png";